// Auto-generated by scripts/generate-version.js
export const APP_VERSION = 'v2.8.88';
export default APP_VERSION;
